import { isDiscordActivity } from '@/utils/discordActivity';

export const KICK_COOLDOWN_MS = 15000;

export function getColyseusEndpoint(): string {
  // Discord Activity: always route through Discord URL mappings (CSP-safe).
  // This must override VITE_COLYSEUS_ENDPOINT if it's set.
  if (isDiscordActivity() && typeof window !== 'undefined') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/.proxy/colyseus`;
  }

  const configured = import.meta.env.VITE_COLYSEUS_ENDPOINT?.trim();
  if (configured) return configured;

  if (import.meta.env.DEV) {
    return 'ws://localhost:2567';
  }

  if (typeof window !== 'undefined') {
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${window.location.host}`;
  }

  return 'ws://localhost:2567';
}
